export const FETCH_BARANGAYS = `${process.env.REACT_APP_API_URL}/barangays`;
export const CREATE_BARANGAY = `${process.env.REACT_APP_API_URL}/barangays`;
export const UPDATE_BARANGAY = `${process.env.REACT_APP_API_URL}/barangays`;
export const DELETE_BARANGAY = `${process.env.REACT_APP_API_URL}/barangays`;
